<template>
  <div class="Login d-flex flex-column justify-content-center">
    <div class="row justify-content-center mt--50">
      <div class="col-12 text-center">
        <img
          alt="logo"
          src="/images/logo/logo.png"
          width="100%;"
          style="max-width: 450px;"
        />
      </div>
      <div class="col-md-6 col-10 text-center" style="max-width: 430px;">
        <form class="login" @submit.prevent="login()">
          <div class="input-group-prepend mt-4">
            <span class="input-group-text2" id="basic-addon">
              <i class="fas fa-user prefix mb-1 ml-1"></i>
            </span>

            <input
              v-model="username"
              type="text"
              class="form-control2"
              placeholder="Username"
              @keypress="isCharacter($event)"
            />
          </div>
          <div class="input-group-prepend mt-3">
            <span class="input-group-text2" id="basic-addon">
              <i class="fas fa-lock prefix mb-1 ml-1"></i>
            </span>

            <input
              v-model="password"
              type="password"
              class="form-control2"
              placeholder="Password"
            />
          </div>
          <div class="text-right text-white my-2">
            <a @click="modalforgetpassword = true"
              ><small>ลืมรหัสผ่าน</small></a
            >
          </div>
          <mdb-btn class="btn-login font16" block @click="checklogin()"
            >เข้าสู่ระบบ</mdb-btn
          >
        </form>

        <router-link to="/Register">
          <mdb-btn class="btn-register color_back font16 mt-3" block
            >สมัครสมาชิก</mdb-btn
          >
        </router-link>
      </div>
    </div>
    <nav class="navbar-bottom fixed-bottom py-3">
      <div class="row justify-content-center" style="z-index:1;">
        <img class="image1" src="/images/bg2.png" style="height:200px;" />
      </div>
      <div class="row justify-content-center" style="z-index:2;">
        <img class="image1" src="/images/bg.png" height="100%" width="100%" />
      </div>
    </nav>
    <mdb-modal
      :show="modalforgetpassword"
      @close="modalforgetpassword = false"
      centered
    >
      <div class="container">
        <forgetpassword />
      </div>
    </mdb-modal>
  </div>
</template>

<script>
// import axios from "axios";
import { mdbModal } from "mdbvue";
import forgetpassword from "@/components/forgetpassword";
const jwt = require("jsonwebtoken");
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Login",
  components: {
    mdbModal,
    forgetpassword,
  },
  data() {
    return {
      username: "",
      password: "",
      errors: [],
      modalforgetpassword: false,
    };
  },
  computed: {
    ...mapGetters({
      isLogin: "isLogin",
      user: "user",
      token: "token",
    }),
  },
  methods: {
    ...mapActions({
      storeLogin: "login",
    }),
    isCharacter: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode < 48 ||
        (charCode > 57 && charCode < 65) ||
        (charCode > 90 && charCode < 97) ||
        charCode > 122
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    checklogin: function() {
      this.errors = [];
      if (this.username == "") {
        this.errors.push("กรุณากรอกชื่อผู้ใช้งาน");
        return this.$swal({
          title: "ชื่อผู้ใช้งาน",
          text: "กรุณากรอกชื่อผู้ใช้งาน",
          icon: "warning",
          timer: 5000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
      if (this.password.length < 8) {
        this.errors.push("กรุณากรอกรหัสผ่าน 8 - 16 ตัว");
        return this.$swal({
          title: "รหัสผ่าน",
          text: "กรุณากรอกรหัสผ่าน 8 - 16 ตัว",
          icon: "warning",
          timer: 5000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
      this.login();
    },
    login: function() {
      if (this.errors.length === 0) {
        let payload = {
          username: this.username,
          password: this.password,
          ip_login: this.ipuser,
        };
        let token = jwt.sign(payload, this.$keypayload, {
          expiresIn: "60000s",
        });
        this.$axios
          .post("/login", { token: token })
          .then((response) => {
            if (response.data.code != "1") {
              // this.$session.set('isLogin', true)
              // this.$session.set('token', response.data)
              this.storeLogin(response.data);
              this.$router.push("/");
            } else {
              this.$swal({
                title: "เข้าสู่ระบบ",
                text: response.data.msg,
                icon: "error",
                timer: 5000,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    // const config = {
    //   method: "get",
    //   url: "https://api.ipify.org",
    //   headers: {},
    // };
    // console.log(config);
    // axios
    //   .get(config)
    //   .then((response) => {
    //     this.ipuser = "" + response.data;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch("https://api.ipify.org", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        this.ipuser = "" + result;
      })
      .catch((error) => console.log("error", error));
  },
};
</script>

<style>
.Login {
  background: #131313;
  height: 100vh;
  width: 100%;
  position: relative;
  overflow-x: hidden;
}
.btn-login {
  color: #ffffff;
  background-color: #f5904b !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25),
    inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 18px !important;
  padding: 10px 15px 10px 15px;
  margin-top: 30px !important;
}
.btn-register {
  color: #000000;
  background-color: #f2f2f2 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25),
    inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 18px !important;
  padding: 10px 15px 10px 15px;
}
</style>
